<template>
  <button class="wishlist-button" :class="{ selected: wishlistselected }" @click="toggleWishlist">
    <span v-if="wishlistselected">
      <img :src="wishlistImg" class="wishlistImg" :alt="wishlistAlt" />
    </span>
    <span v-else>
      <img :src="unwishlistImg" class="wishlistImg" :alt="unwishlistAlt" />
    </span>
  </button>
</template>

<script>
import eventBus from '@loreal/eventbus-js';
const WISHLIST_UPDATED = 'wishlist-updated';
export default {
  name: 'FavouriteArticle',
  props: {
    wishlistImg: { type: String, required: true },
    unwishlistImg: { type: String, required: true },
    wishlistAlt: {
      type: String,
      default: '',
    },
    unwishlistAlt: {
      type: String,
      default: '',
    },
    title: { type: String, default: null },
    url: { type: String, default: null },
    imageSrc: { type: String, default: null },
    imageSrcset: { type: String, default: null },
    imageAlt: { type: String, default: null },
  },
  data() {
    return {
      wishlistItems: [],
      wishlistselected: false,
    };
  },
  computed: {
    isInWishlist() {
      return this.wishlistItems.some((item) => item.url === this.resolvedArticleUrl);
    },
    resolvedTitle() {
      return this.title || document.querySelector('[data-tag-articletitle]')?.innerText || '';
    },
    resolvedImageSrcset() {
      return (
        this.imageSrcset ||
        document.querySelector('[data-tag-articleimage]')?.srcset ||
        document.querySelector('[data-tag-articleimage]')?.src ||
        ''
      );
    },
    resolvedImageAlt() {
      return this.imageAlt || this.resolvedTitle;
    },
    resolvedArticleUrl() {
      return this.url || window.location.pathname;
    },
  },
  mounted() {
    this.loadWishlist();
    eventBus.on(WISHLIST_UPDATED, this.loadWishlist);
    window.addEventListener('storage', this.onStorageChange);
  },
  beforeUnmount() {
    eventBus.off(WISHLIST_UPDATED, this.loadWishlist);
    window.removeEventListener('storage', this.onStorageChange);
  },
  methods: {
    onStorageChange(event) {
      if (event.key === 'likedArticles') {
        this.loadWishlist();
      }
    },
    loadWishlist() {
      const storedArticles = localStorage.getItem('likedArticles');
      this.wishlistItems = storedArticles ? JSON.parse(storedArticles) : [];
      this.updateflags();
    },
    triggerGtm(val) {
      const articleLikeDislikeObj = {
        event: 'uaevent',
        ecommerce: 'undefined',
        eventCategory: 'Wishlist',
        eventAction: 'Article Wishlist',
        eventLabel: this.resolvedTitle,
        article_info: this.resolvedTitle,
        event_name: val,
      };
      window.dataLayer?.push(articleLikeDislikeObj);
    },
    toggleWishlist() {
      if (this.isInWishlist) {
        this.removeFromWishlist();
        this.triggerGtm('remove_from_wishlist');
      } else {
        this.addToWishlist();
        this.triggerGtm('add_to_wishlist');
      }
    },
    addToWishlist() {
      if (this.isInWishlist) return;

      const newItem = {
        url: this.resolvedArticleUrl,
        itemResult: {
          image: {
            dataSrcset: this.resolvedImageSrcset,
            alt: this.resolvedImageAlt,
          },
          title: this.resolvedTitle,
        },
      };

      this.wishlistItems.push(newItem);
      this.updateLocalStorage();
    },
    removeFromWishlist() {
      this.wishlistItems = this.wishlistItems.filter(
        (item) => item.url !== this.resolvedArticleUrl
      );
      this.updateLocalStorage();
    },
    updateLocalStorage() {
      localStorage.setItem('likedArticles', JSON.stringify(this.wishlistItems));
      eventBus.emit(WISHLIST_UPDATED);
      this.updateflags();
    },
    updateflags() {
      this.wishlistselected = this.isInWishlist;
    },
  },
};
</script>

<style scoped>
.wishlistImg {
  width: 30px;
}
</style>
